<template>
  <el-container style="height: 100%;">
    <el-header height="auto">
      <el-form class="ciFilterDiv" :inline="true">
        <el-form-item>
          <el-button
            @click="formAdd(1)"
            style="margin:10px 0px 10px 0px;"
            size="small"
            type="primary"
            icon="el-icon-plus"
            plain
            >新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="请输入子目名称搜索"
            v-model="filterName"
            class="input-with-select"
            size="small"
            style="width: 250px; float: right; margin-top: 9px"
            clearable>
        <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
        </el-input>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main class="nopadding">
        <el-table
          border
          stripe
          size="small"
          ref="singleTable"
          :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
          :data="tableData"
          :highlight-current-row="true"
          >
          <el-table-column property="loginUrl" label="首页地址" width="100"></el-table-column>
          <el-table-column property="logoutUrl" label="登录地址" width="100"></el-table-column>
          <el-table-column property="homeFrameUrl" label="首页信息地址" width="100"></el-table-column>
          <el-table-column property="homeLogoUrl" align="center" label="首页LOGO"></el-table-column>
          <el-table-column property="sloganUrl" align="center" label="首页标语"></el-table-column>
          <el-table-column property="defaultProjectName" align="center" label="默认显示项目名称" width="100"></el-table-column>
          <el-table-column property="loginLogoUrl" align="center" label="登录页LOGO"></el-table-column>
          <!-- <el-table-column property="attaId" align="center" label="APP"></el-table-column> -->
          <el-table-column property="loginProjectName" align="center" label="登录页项目名称" width="100"></el-table-column>
          <el-table-column property="loginSubName" align="center" label="登录页项目副名称" width="100"></el-table-column>
          <el-table-column property="downloadUrl" align="center" label="登录页下载跳转地址" width="100"></el-table-column>
          <el-table-column property="copyright" align="center" label="登录页版权" width="100"></el-table-column>
          <el-table-column property="userState" align="center" label="是否启用在线状态" width="100">
            <template slot-scope="scope">
              {{scope.row.userState === 1 ? '是' : '否'}}
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                title="编辑"
                circle
                plain
                @click="formEdit(scope.$index, scope.row)"></el-button>
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                title="删除"
                circle
                plain
                @click="formDelete(scope.$index, scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-main>
    <el-footer height="auto">
      <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[15]"
            :page-size="rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
    </el-footer>
    <el-dialog title="页面信息" width="80%" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <el-form :model="resourceForm" :rules="rules" ref="resourceForm" :inline="true" :label-width="formLabelWidth">
            <el-form-item label="首页地址" prop="loginUrl">
              <el-input v-model="resourceForm.loginUrl" placeholder="登录后首页地址，默认：/home"></el-input>
            </el-form-item>
            <el-form-item label="登录地址">
              <el-input v-model="resourceForm.logoutUrl" placeholder="登录地址，默认：/"></el-input>
            </el-form-item>
            <el-form-item label="首页项目名称">
              <el-input v-model="resourceForm.defaultProjectName" placeholder="首页项目名称"></el-input>
            </el-form-item>
            <el-form-item label="首页信息地址">
              <el-input v-model="resourceForm.homeFrameUrl" placeholder="默认:/defaultImg,图片地址:defaultImgByConfig"></el-input>
            </el-form-item>
            <el-form-item label="首页背景图">
              <el-upload
                class="upload-demo"
                action="/api/zuul/fs/files/upload"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList5"
                list-type="picture"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :multiple ="false"
                :limit="1"
                :data="{'metaData.formId': this.resourceForm.id,'metaData.fileName': '首页背景图','metaData.fileType': 'homeUrl'}"
                :on-success="handleAvatarSuccess">
                <el-button style="margin:10px 0px 10px 10px;" size="small" icon="el-icon-plus" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">上传后必须保存！否则不生效！</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="首页LOGO">
              <!-- <el-input v-model="resourceForm.homeLogoUrl" placeholder="首页LOGO"></el-input> -->
              <el-upload
                class="upload-demo"
                action="/api/zuul/fs/files/upload"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList1"
                list-type="picture"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :multiple ="false"
                :limit="1"
                :data="{'metaData.formId': this.resourceForm.id,'metaData.fileName': '首页Logo','metaData.fileType': 'homeLogoUrl'}"
                :on-success="handleAvatarSuccess">
                <el-button style="margin:10px 0px 10px 10px;" size="small" icon="el-icon-plus" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">上传后必须保存！否则不生效！</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="首页标语">
              <!-- <el-input v-model="resourceForm.sloganUrl" placeholder="标语URL"></el-input> -->
              <el-upload
                class="upload-demo"
                action="/api/zuul/fs/files/upload"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList2"
                list-type="picture"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :multiple ="false"
                :limit="1"
                :data="{'metaData.formId': this.resourceForm.id,'metaData.fileName': '标语','metaData.fileType': 'sloganUrl'}"
                :on-success="handleAvatarSuccess">
                <el-button style="margin:10px 0px 10px 10px;" size="small" icon="el-icon-plus" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">上传后必须保存！否则不生效！</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="登录页LOGO">
              <!-- <el-input v-model="resourceForm.loginLogoUrl" placeholder="登录页LOGO"></el-input> -->
              <el-upload
                class="upload-demo"
                action="/api/zuul/fs/files/upload"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList3"
                list-type="picture"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :multiple ="false"
                :limit="1"
                :data="{'metaData.formId': this.resourceForm.id,'metaData.fileName': '登录页LOGO','metaData.fileType': 'loginLogoUrl'}"
                :on-success="handleAvatarSuccess">
                <el-button style="margin:10px 0px 10px 10px;" size="small" icon="el-icon-plus" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">上传后必须保存！否则不生效！</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="登录页背景图">
              <el-upload
                class="upload-demo"
                action="/api/zuul/fs/files/upload"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList6"
                list-type="picture"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :multiple ="false"
                :data="{'metaData.formId': this.resourceForm.id,'metaData.fileName': '登录页背景图','metaData.fileType': 'loginBgUrl'}"
                :on-success="handleAvatarSuccess">
                <!-- :limit="1" -->
                <el-button style="margin:10px 0px 10px 10px;" size="small" icon="el-icon-plus" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">可上传多个，轮播图！</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="登录页项目名称">
              <el-input v-model="resourceForm.loginProjectName" placeholder="登录页项目名称"></el-input>
            </el-form-item>
            <el-form-item label="新闻动态名称">
              <el-input v-model="resourceForm.newsTitle" placeholder="新闻动态名称"></el-input>
            </el-form-item>
            <el-form-item label="登录页项目副名称">
              <el-input v-model="resourceForm.loginSubName" placeholder="登录页项目副名称"></el-input>
            </el-form-item>
            <el-form-item label="登录页下载跳转地址">
              <el-input v-model="resourceForm.downloadUrl" placeholder="登录页下载跳转地址"></el-input>
            </el-form-item>
            <el-form-item label="登录页版权" style="width: 100%;">
              <el-input v-model="resourceForm.copyright" placeholder="Copyright 2019 有限公司 版权所有"></el-input>
            </el-form-item>
            <el-form-item label="Android二维码">
              <el-upload
                class="upload-demo"
                action="/api/zuul/fs/files/upload"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList7"
                list-type="picture"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :multiple ="false"
                :limit="1"
                :data="{'metaData.formId': this.resourceForm.id,'metaData.fileName': 'Android二维码','metaData.fileType': 'loginAndroidUrl'}"
                :on-success="handleAvatarSuccess">
                <el-button style="margin:10px 0px 10px 10px;" size="small" icon="el-icon-plus" type="primary">选择文件</el-button>
                <!-- <div slot="tip" class="el-upload__tip">可上传多个，轮播图！</div> -->
              </el-upload>
            </el-form-item>
            <el-form-item label="ios二维码">
              <el-upload
                class="upload-demo"
                action="/api/zuul/fs/files/upload"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList8"
                list-type="picture"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :multiple ="false"
                :limit="1"
                :data="{'metaData.formId': this.resourceForm.id,'metaData.fileName': 'ios二维码','metaData.fileType': 'loginIosUrl'}"
                :on-success="handleAvatarSuccess">
                <el-button style="margin:10px 0px 10px 10px;" size="small" icon="el-icon-plus" type="primary">选择文件</el-button>
                <!-- <div slot="tip" class="el-upload__tip">可上传多个，轮播图！</div> -->
              </el-upload>
            </el-form-item>
            <el-form-item label="登录页头部口号">
              <el-upload
                class="upload-demo"
                action="/api/zuul/fs/files/upload"
                :before-upload="beforeAvatarUpload"
                :file-list="TopSloganfileList"
                list-type="picture"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :multiple ="false"
                :limit="1"
                :data="{'metaData.formId': this.resourceForm.id,'metaData.fileName': '登录页头部口号','metaData.fileType': 'loginTopSloganUrl'}"
                :on-success="handleAvatarSuccess">
                <el-button style="margin:10px 0px 10px 10px;" size="small" icon="el-icon-plus" type="primary">选择文件</el-button>
                <!-- <div slot="tip" class="el-upload__tip">可上传多个，轮播图！</div> -->
              </el-upload>
            </el-form-item>
            <el-form-item label="是否启用在线状态">
              <el-switch
                v-model="resourceForm.userState"
                active-color="#409eff"
                inactive-color="#dcdfe6"
                active-value="1"
                inactive-value="0">
              </el-switch>
            </el-form-item>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="APP上传">
              <el-upload
                class="upload-demo"
                action="/api/loginConfig/addAtta"
                :before-upload="beforeAvatarUpload1"
                :file-list="fileList4"
                list-type="file"
                :on-remove="handleRemove"
                :multiple ="false"
                name="attaFile"
                :limit="1"
                :data="{'sysId': this.resourceForm.id,'attaType': '1'}"
                :on-success="handleAvatarSuccess">
                <el-button style="margin:10px 0px 10px 10px;" size="small" icon="el-icon-plus" type="primary">选择文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formSave('resourceForm')">保 存</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name: 'loginConfig',
  data () {
    return {
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      fileList8: [],
      TopSloganfileList:[],
      filterName: "",
      tableData: [],
      dialogFormVisible: false,
      dialogRolesVisible: false,
      resourceForm: {},
      formLabelWidth: '120px',
      total: 0,
      rows: 15,
      currentPage: 1,
      selectResourceId: '',
      rules: {
        resourceName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符之间', trigger: 'blur' }
        ],
      }
    }
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    handleSizeChange (val) {
      this.rows = val
      this.currentPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    getList: function () {
      this.$axios.post(
        "/api/loginConfig/getList",
        {
          params:{
            name: this.filterName,
            page: this.currentPage,
            rows: this.rows
          }
        }
      ).then(data => {
        if (data && data.data && data.data.rows && data.data.rows.length > 0) {
          this.tableData = data.data.rows;
          this.total = data.data.total;
        }else{
          this.tableData=[];
          this.total=0;
        }
      }).catch(error => {
        console.log("error:" + error.toString());
      })
    },
    formAdd () {
      this.fileList1 = [];
      this.fileList2 = [];
      this.fileList3 = [];
      this.fileList4 = [];
      this.fileList5 = [];
      this.fileList6 =[];
      this.fileList7 =[];
      this.fileList8 =[];
      this.TopSloganfileList=[]
      if (this.$refs.resourceForm) {
        this.$refs.resourceForm.clearValidate()
      }
      //获取id
      this.$axios.get(
          "/api/common/getNewId"
      ).then(res => {
          this.resourceForm={
            id: res.data.digitalId,
          };
          this.dialogFormVisible = true
      }).catch(err => {
        // this.$message.error(err)
      })
      this.resourceForm={
        id: "1111111111111111",
      };
      this.dialogFormVisible = true
    },
    formSave (resourceForm) { // 保存节点
      this.$refs[resourceForm].validate((valid) => {
        if (valid) {
          var url = "/api/loginConfig/save";
          delete this.resourceForm.createTime;
          this.$axios.post(
            url,
            this.$qs.stringify({
              strJson : JSON.stringify(this.resourceForm)
            })
          ).then(data => {
            if (data.data.succeed) {
              this.resourceForm = {};
              this.dialogFormVisible = false
              this.getList();
            } else {
              this.$message({
                message: data.data.msg,
                showClose: true,
                type: 'error'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    formEdit (index, row) {
      this.fileList1 = [];
      this.fileList2 = [];
      this.fileList3 = [];
      this.fileList4 = [];
      this.fileList5 = [];
      this.fileList6=[];
      this.fileList7=[];
      this.fileList8=[];
      this.TopSloganfileList=[]
      if (this.$refs.resourceForm) {
        this.$refs.resourceForm.clearValidate()
      }
      console.log(row);
      this.resourceForm = Object.assign({},row);
      if (this.resourceForm.userState === 1) {
        this.resourceForm.userState = '1'
      } else {
        this.resourceForm.userState = '0'
      }
      this.getFilesData(row.id);
      this.getFilesData(row.id,"1");
      this.dialogFormVisible = true;
    },
    formDelete (index, row) {
      this.$confirm('是否删除?', '提示', {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(
          "/api/loginConfig/del",
          this.$qs.stringify({id: row.id})
        ).then(data => {
          if (data.data.succeed) {
            this.getList();
          } else {
            this.$message({
              message: data.data.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          showClose: true,
          message: '已取消删除'
        })
      })
    },
    //上传前校验
    beforeAvatarUpload(file){
      let fileName = file.name.toLowerCase();
      const isExcel = (fileName.indexOf(".png")!=-1 || fileName.indexOf(".jpeg")!=-1 || fileName.indexOf(".jpg")!=-1);
      if (!isExcel) {
        this.$message.error('logo只能是 图片!');
      }
      return isExcel;
    },
    //上传前校验
    beforeAvatarUpload1(file){
      let fileName = file.name.toLowerCase();
      const isExcel = (fileName.indexOf(".apk")!=-1);
      if (!isExcel) {
        this.$message.error('APP只能上传apk文件!');
      }
      return isExcel;
    },
    //删除选择文件
    handleRemove(file, fileList) {
      if(!file.metaData){
        this.resourceForm.attaId = "";
        return;
      }
      if(file.metaData.fileType=="homeLogoUrl"){
        this.resourceForm.homeLogoUrl = "";
      }else if(file.metaData.fileType=="sloganUrl"){
        this.resourceForm.sloganUrl = "";
      }else if(file.metaData.fileType=="loginLogoUrl"){
        this.resourceForm.loginLogoUrl = "";
      }
      this.$axios.delete('/api/fs/files/delete/'+file.id).then(res => {
        this.getFilesData(file.metaData.formId,file.metaData.fileType);
      }).catch(error => {
          console.log('error:' + error.toString())
      })
    },
    //Excel上传成功,重新刷新数据
    handleAvatarSuccess(res, file){
      console.log("上传成功",res);
      if(!res.metaData){
        this.resourceForm.attaId = res.data;
        return;
      }
      if(res.metaData.fileType=="homeLogoUrl"){
        this.resourceForm.homeLogoUrl = res.id;
      }else if(res.metaData.fileType=="sloganUrl"){
        this.resourceForm.sloganUrl = res.id;
      }else if(res.metaData.fileType=="loginLogoUrl"){
        this.resourceForm.loginLogoUrl = res.id;
      }else{
        this.getFilesData(res.metaData.formId,res.metaData.fileType);
      }
      // this.options = res;
    },
    //点击图片
    handlePreview(file){
      window.open("/api/fs/files/download/"+file.id);
    },
    //获取table数据
    getFilesData(bizPk,type) {
      if(type=="1"){
        this.fileList4 =[];
        this.$axios.post('/api/loginConfig/getQrCode/'+bizPk).then(res => {
          if(res){
            var item = {
              name: 'APK',
              url: res.data
            };
            // console.log(res.data);
            this.fileList4.push(item);
          }
        }).catch(error => {
            console.log('error:' + error.toString())
        })
      }else{
        if(type=="homeLogoUrl"){
          this.fileList1 =[];
        }else if(type=="homeUrl"){
          this.fileList5 =[];
        }else if(type=="loginBgUrl"){
          this.fileList6 =[];
        }else if(type=="loginAndroidUrl"){
          this.fileList7 =[];
        }else if(type=="loginIosUrl"){
          this.fileList8 =[];
        }else if(type=="sloganUrl"){
          this.fileList2 =[];
        }else if(type=="loginLogoUrl"){
          this.fileList3 =[];
        }else if(type=="loginTopSloganUrl"){
          this.TopSloganfileList =[];
        }
        //
        let params = {
          'metaData.formId': bizPk,
          'metaData.fileType': type
        }
        this.$axios.post('/api/fs/files/search',this.$qs.stringify(params)).then(res => {
          if(res.data && res.data.length>0){
            res.data.map((item,index)=>{
              item.name = item.metaData.fileName;
              item.url = "/api/fs/files/download/"+item.id;
              if(item.metaData.fileType=="homeLogoUrl"){
                this.fileList1.push(item);
              }else if(item.metaData.fileType=="homeUrl"){
                this.fileList5.push(item);
              }else if(item.metaData.fileType=="loginBgUrl"){
                this.fileList6.push(item);
              }else if(item.metaData.fileType=="loginAndroidUrl"){
                this.fileList7.push(item);
              }else if(item.metaData.fileType=="loginIosUrl"){
                this.fileList8.push(item);
              }else if(item.metaData.fileType=="sloganUrl"){
                this.fileList2.push(item);
              }else if(item.metaData.fileType=="loginLogoUrl"){
                this.fileList3.push(item);
              }else if(item.metaData.fileType=="loginTopSloganUrl"){
                this.TopSloganfileList.push(item);
              }
            })
          }
        }).catch(error => {
            console.log('error:' + error.toString())
        })
      }

    },
  }
}
</script>

<style scoped>
  .nopadding {
      padding: 0 20px;
  }
  .el-upload__tip{
    color: red;
    margin-top: 0;
    line-height: 20px;
  }
</style>
<style lang="less" scoped>
    @import "../styles/element-ui-reset.less";
    </style>



// WEBPACK FOOTER //
// src/views/LoginConfig.vue